import { CircularProgress } from "@mui/material";

function LoadingPage() {
    return (
        <>
            <div>
                <div style={{ position: "relative", top: "260px", textAlign: "center" }}>
                    {/* <img src={stripeImage} alt="imaga while excution of the payment" style={{ width: "100%" }} /> */}
                    <div className=''>
                        <CircularProgress />
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoadingPage;